export default __webpack_public_path__ + "static/media/Planets - Preview 2.beb1409e.png";